/*eslint-disable*/
import Cookies from 'js-cookie';

const username = 'test-client';
const password = 'test-client';

export const basicAuth = btoa(`${username}:${password}`);
export const bearerToken = Cookies.get('token');
